import breakTo from '../../styles/tools/breakTo'
import genericsFn from '../../styles/generics/styles'

export default ({ colors, images, fontFamilies, fontWeights, fontSizes }) => {
  const generics = genericsFn({ colors, fontFamilies, fontWeights, fontSizes })

  const styles = {
    img: {
      width: '20rem',
      height: '15rem',
      margin: '2rem auto',

      backgroundImage: images.notfound,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center',

      [breakTo('small')]: {
        width: '35rem',
        height: '25rem'
      }
    }
  }

  return { ...generics, ...styles }
}



// WEBPACK FOOTER //
// ./containers/notFound/styles.js